// Format helpers
export function fmtSec(seconds) {
  if (seconds == null) return "—";
  const s = Math.max(0, Math.floor(seconds));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m ${sec.toString().padStart(2, "0")}s`;
  if (m > 0) return `${m}m ${sec.toString().padStart(2, "0")}s`;
  return `${sec}s`;
}

export function fmtCompact(seconds) {
  if (seconds == null) return "—";
  const s = Math.max(0, Math.floor(seconds));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${s}s`;
}

export function fmtMoney(n) {
  if (n == null || n === "" || isNaN(n)) return "—";
  return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n);
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export const STATUS_META = {
  NEW: { label: "New", color: "info" },
  IN_PROGRESS: { label: "In Progress", color: "warning" },
  ESCALATED_TO_BANK: { label: "Escalated to Bank", color: "awaiting" },
  AWAITING_FINAL_STATUS: { label: "Awaiting Final Status", color: "awaiting" },
  RESOLVED: { label: "Resolved", color: "success" },
  CLOSED: { label: "Closed", color: "muted" },
};

export const FINAL_STATUS_META = {
  SUCCESS: { label: "Success", color: "success" },
  FAILED: { label: "Failed", color: "error" },
  NO_FUNDS: { label: "No Funds Received", color: "error" },
  NOT_FOUND: { label: "Not Found", color: "warning" },
  "": { label: "—", color: "muted" },
};

export const COLOR_CLASSES = {
  success: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  warning: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  error: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  info: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  awaiting: "bg-violet-500/10 text-violet-400 border-violet-500/30",
  muted: "bg-slate-500/10 text-slate-400 border-slate-500/30",
};

export const PRESENCE_DOT = {
  online: "bg-emerald-500",
  away: "bg-amber-500",
  offline: "bg-slate-600",
};
